var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_110)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1870,
    transform: "translate(-482 -856)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#FF4067"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 7.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18.5L18 8",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1870,
    fill: "white",
    transform: "translate(-482 -856)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelled);
export default __webpack_public_path__ + "static/media/cancelled.225bdfe7f23e308afe4ddca47a7a0f0f.svg";
export { ForwardRef as ReactComponent };